import { defineMessages } from 'react-intl';

/** User-facing Work copy for failures, retries, and related status surfaces. */
export const projectRunFailureMessages = defineMessages({
  bannerTitle: {
    defaultMessage: 'Something went wrong',
    id: 'pX7YJOtWmZ',
    description: 'Work chat failure banner title when a turn cannot complete',
  },
  bannerDescription: {
    defaultMessage:
      "Heidi couldn't finish that request. Send another message and we'll try again.",
    id: 'ALl64JdK6V',
    description: 'Work chat failure banner helper text with a retry action',
  },
  composerPlaceholder: {
    defaultMessage: 'Something went wrong. Send another message to try again…',
    id: '/mwvZXdiJN',
    description: 'Work chat composer placeholder after a failed turn',
  },
  composerQueuePlaceholder: {
    defaultMessage: 'Reply while Heidi works. Your message will queue…',
    id: 'h5dzyJK8C8',
    description: 'Work chat composer placeholder while a turn is in flight',
  },
  composerClarificationReplyPlaceholder: {
    defaultMessage: 'Type your answer and send…',
    id: 'UgZk3/0Rkk',
    description:
      'Work chat composer placeholder while Heidi waits for a clarification answer in the transcript',
  },
  stopHeidi: {
    defaultMessage: 'Stop Heidi',
    id: 'X0NxywV1wL',
    description: 'Aria label for stopping Heidi while wrapping up after a desktop task',
  },
  infraToolError: {
    defaultMessage:
      'Heidi hit a temporary issue on this step. Please try again in a moment.',
    id: '6Gim0wDFlB',
    description: 'Friendly tool error when the raw backend message is infra noise',
  },
  evidenceSearchFailed: {
    defaultMessage: "Evidence search didn't complete. Try asking again.",
    id: 'WZkaggZwSf',
    description: 'Inline error when an evidence search child run fails with no output',
  },
  evidencePartialResults: {
    defaultMessage: "Couldn't finish the evidence search. Showing partial results.",
    id: 'PfrTc2ecuj',
    description:
      'Inline notice when an evidence search errors after partial output landed',
  },
  verifyPartialResults: {
    defaultMessage: "Couldn't finish tracing every source. Showing what we found.",
    id: 'wJkjWCbHid',
    description:
      'Inline notice when a Verify child run errors after partial provenance output',
  },
  approvalOptionalNote: {
    defaultMessage: "Optional note for Heidi (e.g. 'use Dr Smith's letterhead')",
    id: 'tNN2d49ogP',
    description: 'Placeholder on Work approval cards for an optional clinician note',
  },
});
